<template>
  <div class="default_entry">
    <div class="entry_table">
      <div class="table_title">
        <div class="table_title_left">
          默认入口
        </div>
        <div class="table_title_right">
          用户权限
        </div>
        <div class="table_title_op">
          操作
        </div>
      </div>
      <div class="table_list" v-for="(item,index) in entryData" :key="index">
        <div class="select_entry">
          <el-select v-model="item.entranceCode" placeholder="请选择" @change="changeEntry($event,index)">
            <el-option
                v-for="item in entryList"
                :key="item.entranceCode"
                :label="item.entranceName"
                :value="item.entranceCode"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 新版本选择咨询范围---增加了条件 -->
        <div class="right-consultation-scope">
          <div class="right-consultation-scope-top"
               v-for="(conditionsItem,conditionsIndex) in item.conditions"
               :key="conditionsIndex">
            <div
                class="right-consultation-scope-top-content"
                :class="conditionsItem.type === '' ? 'error-content' : ''"
            >
              <div class="select-cell-attr select-cell-inner">
                <el-popover
                    :ref="'condition-popover'+ conditionsIndex + index"
                    placement="bottom-start"
                    width="300"
                    v-model="conditionsItem.visible"
                    popper-class="choose-conditions-poprver"
                    :visible-arrow="false">
                  <div
                      :class="['choose-user-attrible one-column-ellipsis']"
                      slot="reference">
                    <span class="all-select" style="display: block;width: 220px;" v-if="conditionsItem.type === ''">{{ $t('common.selectPlaceholder') }}</span>
                    <span class="all-select" style="display: block;width: 220px;" v-else-if="conditionsItem.type === 'ALL'">{{ $t("botLink.allPerson") }}</span>
                    <span
                        v-else-if="conditionsItem.type === 'STAFF_OR_DEPARTMENT'">{{
                        $t("botLink.staffOrDept")
                      }}</span>
                    <span
                        v-else-if="conditionsItem.type === 'CUSTOMIZE' && conditionsItem.key === 'label'">{{
                        $t("botLink.label")
                      }}</span>
                    <span
                        v-else-if="conditionsItem.type === 'CUSTOMIZE' && conditionsItem.key === 'personalJobLevel'">{{
                        $t("botLink.personalJobLevel")
                      }}</span>
                  </div>
                  <el-tree
                      style="max-height:300px;overflow-x:hidden;overflow-y:auto;"
                      :data="userAttributeOptions"
                      :props="{
                      children: 'children',
                      label: 'label',
                      id:'value',
                      }"
                      default-expand-all
                      node-key="id"
                      @node-click="(data) => onNodeClickCondition(data,conditionsItem,conditionsIndex)"
                      ref="userAttributeTree">
                  <span :class="['custom-tree-node',  data.value === 'STAFF'  ? 'disabled' : '']"
                        slot-scope="{node,data}">
                    <span class="custom-tree-node-left">
                      <span class="data-label">{{ $t("botLink." + data.value) }}</span>
                    </span>
                  </span>
                  </el-tree>
                </el-popover>
              </div>
              <template v-if="conditionsItem.type != ''">
                <div class="select-cell-attreq select-cell-inner" v-if="conditionsItem.type !== 'ALL'">
                  <el-select
                      size="small"
                      v-model="conditionsItem.relation"
                      :placeholder="$t('flowComponent.conditionConfigPopup.selectType')">
                    <el-option
                        v-for="item in attrRelations"
                        :key="item.value"
                        :label="$t('common.' + item.value)"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </div>
                <!-- 弹框选择组织架构 -->
                <div
                    @click="openStaffPopup(conditionsItem,conditionsIndex,item,index)"
                    class="select-cell-attrv select-cell-inner one-column-ellipsis"
                    v-if="conditionsItem.relation !== 'IS_NULL' && conditionsItem.relation !== 'IS_NOT_NULL' && conditionsItem.type !== 'ALL'">
                  <template v-if="conditionsItem.type === 'STAFF_OR_DEPARTMENT'">
                    <template v-if="conditionsItem.expect && conditionsItem.expect.length > 0">
                    <span class="have-checked-intent" style="cursor: pointer;color:#606266;"
                          v-for="(tagCell, tagCellIndex) in conditionsItem.expect" :key="tagCellIndex">
                      <open-data :type="tagCell.type == 1 ? 'departmentName': 'userName'"
                                 :openid="tagCell.name" v-if="isOpenData()"></open-data>
                      <span v-else>{{ tagCell.name }}</span>
                      <span v-if="tagCellIndex + 1 < conditionsItem.expect.length">,</span>
                    </span>
                    </template>
                    <div class="placeholder-text" v-else style="cursor: pointer;color:#606266;">
                      {{ $t("common.selectPlaceholder") }}
                    </div>
                  </template>
                  <!-- 下拉选择自定义字段的值 -->
                  <el-select
                      class="choose-tag-select"
                      v-else
                      size="small"
                      v-model="conditionsItem.expect"
                      filterable
                      multiple
                      collapse-tags
                      :placeholder="$t('botLink.inputOrSelect')"
                      style="width: 100%">
                    <el-option
                        v-for="item in tagsOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </template>
            </div>
            <template v-if="conditionsItem.type != ''">
              <div  class="add-condition-bot-btn"
                    v-if="conditionsIndex == 0"
                    @click="addCondition(index)"
              >
                <i class="iconfont guoran-tongyichicun-jiahao"></i>
              </div>
              <div :class="['del-ondition',isFwh ? 'ml' : '']" v-else>
                <i class="iconfont guoran-tongyichicun-16-09-shanchu2"
                   @click="delCondition(conditionsIndex,index)"></i>
              </div>
              <div class="and-box" v-if="conditionsIndex !== item.conditions.length - 1">{{$t('botLink.or')}}</div>
            </template>
          </div>
          <div class="right-consultation-scope-top" :style="{width: 'calc(100% - 25px)'}"
               v-if="item.conditions.length == 0">
            <div class="select-cell-placeholder"  @click="openConditionSelection(item, index)">
              <span >{{$t('common.selectPlaceholder')}}</span>
            </div>
          </div>

        </div>

        <div class="del-bind-bot" v-show="entryData.length > 1">
          <i  class="iconfont guoran-a-18-13"
              @click="delBind(item,index,'')"></i>
        </div>
      </div>
    </div>
    <div class="add_entry" @click="addEntry">
      <div class="addIcon">
        <i class="iconfont guoran-a-16-13"></i>
      </div>
      <span>添加配置</span>
    </div>
    <el-dropdown trigger="click" @command="gotoIntelligentAgentConfig" v-if="false">
      <div class="add_entry">
        <div class="addIcon">
          <i class="iconfont guoran-a-16-13"></i>
        </div>
        <span>添加配置</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <div class="container">
          <el-dropdown-item v-for="(item, index) in entryList" :key="index"
                            class="intelligentAgentItem" :command="item">
            <div class="name">{{ item.entranceName }}</div>
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    <popup @closeEvent="dialogMemberTree = false" v-if="dialogMemberTree" class="choose-consultant-popup">
      <div slot="popup-name">{{ $t("botLink.dialogMemberTitle") }}</div>
      <div slot="popup-con" class="member-contanier">
        <div class="choose-style">
          <div>{{ $t("botLink.dialogMemberTip") }}</div>
          <div class="radio-box">
            <el-radio v-model="chooseStyle" label="all">{{ $t("botLink.askbotClientDrawer.all") }}</el-radio>
            <el-radio v-model="chooseStyle" label="self">{{ $t("botLink.askbotClientDrawer.custom") }}</el-radio>
          </div>
        </div>
        <staffCustomer
            dataType="staff"
            v-if="chooseStyle === 'self'"
            :isMultiple="true"
            @onNodeClick="onNodeClick"
            :memberInfo4Client="memberInfo4Client"
            ref="staffCustomer"></staffCustomer>
      </div>
      <div slot="dialog-footer">
        <el-button @click="cancelChooseMember" plain class="cancel-btn">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="preserStaff" class="confirm-btn">{{ $t("common.confirm") }}</el-button>
      </div>
    </popup>
  </div>
</template>

<script>
import OpenData from "@/components/openData";
import Popup from "@/components/popup";
import StaffCustomer from "../components/staffCustomer";
export default {
  name: "defaultEntry",
  components: { StaffCustomer, Popup, OpenData },
  data(){
    return{
      value:"",
      options:[
        {
          label:"AskService工单系统",
          value:'WORKORDER'
        },
        {
          label:"AskChat即时通讯IM",
          value:"IM"
        },
        {
          label:"AskKMS知识管理系统",
          value:"KNOWLEDGE"
        },
        {
          label:"AskLowCode低代码",
          value:"ASKLOWCODE"
        }
      ],
      entryData:[
        {
          "entranceCode": "",
          "entranceName": "",
          "conditions": []
        }
      ],
      entryList:[
        {
          "entranceCode": "WORKORDER",
          "entranceName": "AskService工单系统",
        },
        {
          "entranceCode": "IM",
          "entranceName": "AskChat即时通讯IM",
        },
        {
          "entranceCode": "KNOWLEDGE",
          "entranceName": "AskKMS知识管理系统",
        },
      ],
      conditions:[
        {
          visible: true,
          type: "",
          expect: [],
          key: "",
          relation: ""
        }
      ],
      userAttributeOptions:[{
        value:"ALL",
        label:"所有人",
      },{
        value:"STAFF",
        label:"员工",
        children:[{
          value:"STAFF_OR_DEPARTMENT",
          label:"员工 / 部门"
        },{
          value:"CUSTOMIZE",
          label:"标签",
          key: 'label',
          type: "SELECT"
        }]
      }],
      attrRelations: [
        { name: "为空", value: "IS_NULL" },
        { name: "不为空", value: "IS_NOT_NULL" },
        { name: "包含任意", value: "CONTAIN_ANY" },
        { name: "不包含任意", value: "NOT_CONTAIN_ANY" },
      ],
      memberInfo4Client: {
        clientInfo: [] // 选中数据
      },
      dialogMemberTree: false,
      activeConditionsIndex:0,
      activeEntry:null,
      activeEntryIndex:0,
      chooseStyle:"",
      chooseStyleOld: "all",
      tagsOptions:[],
      isFwh:false,
      orgTree:[]
    }
  },
  props:{
    bindDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  methods:{
    changeEntry(event,index){
      this.entryData[index].conditions = [];
      let findItem = this.entryList.find(item => item.entranceCode == event);
      this.entryData[index].entranceName = findItem.entranceName;
      console.log('entryData',this.entryData)
    },
    onNodeClickCondition(data, conditionsItem) {
      conditionsItem.visible = false;
      if (data.value === "STAFF") {
        conditionsItem.visible = true;
        return false;
      };
      conditionsItem.type = data.value;
      conditionsItem.key = "";
      conditionsItem.expect = [];
      if (data.value === "CUSTOMIZE") {
        conditionsItem.key = data.key;
      }
    },
    openStaffPopup(conditionsItem, conditionsIndex,item,index) {
      this.activeConditionsIndex = conditionsIndex;
      this.activeEntry = item;
      this.activeEntryIndex = index;
      this.memberInfo4Client.clientInfo = conditionsItem.expect ? JSON.parse(JSON.stringify(conditionsItem.expect)) : [];
      this.chooseStyle = this.memberInfo4Client.clientInfo.length > 0 ? "self" : "all";
      this.dialogMemberTree = true;
    },
    addEntry(){
      this.entryData.push({
        "entranceCode": "",
        "entranceName": "",
        "conditions": []
      })
    },
    addCondition(index) {
      if (!this.entryData[index].conditions){
        this.entryData[index].conditions = []
      }
      this.entryData[index].conditions.push({
        visible: false,
        type: "ALL",
        expect: [],
        key: "",
        relation: "CONTAIN_ANY"
      });
    },
    delCondition(conditionsIndex,index) {
      this.entryData[index].conditions.splice(conditionsIndex, 1);
    },
    delBind(index){
      this.entryData.splice(index,1)
    },
    openConditionSelection(item, index) {
      if (!item.entranceCode){
        this.$message({
          message:"请先选择默认入口",
          type:"warning"
        })
        return
      }
      item.conditions.push({
        visible: true,
        type: "",
        expect: [],
        key: "",
        relation: ""
      });
      setTimeout(() =>{
        this.$refs['condition-popover0' + index][0].doShow()
        console.log(this.$refs['condition-popover0' + index][0], '====')
      },200)
    },
    // 获取自定义标签数据
    getTagsOptions(corpId, callBack){
      this.$http.get(this.requestUrl.bindV2.getTagsOptions).then((res) => {
        console.log('getTagsOptions',res)
        if (res.data.code == 0) {
          this.tagsOptions = res.data.data;
          if (callBack) {
            let tagListIds = [];
            if (this.tagsOptions && this.tagsOptions.length != 0) {
              tagListIds = this.tagsOptions.map(item => item.id);
            }
            localStorage.setItem("ask_tagListIds", tagListIds);
            callBack(tagListIds);
          }
        }
      })
    },
    onNodeClick(node, type, memberInfo) {
      let obj = JSON.parse(JSON.stringify(node));
      obj.name = obj.label || obj.name;
      let AddObj = {
        id: obj.id,
        name: obj.label,
        type: obj.type,
        isWeWorkThirdData: obj.isWeWorkThirdData
      };
      if (obj.checked) {
        obj.ewechat = obj.staffType === "staff-t" ? true : false;
        this.memberInfo4Client.clientInfo.push(AddObj);
        this.memberInfo4Client.clientInfo = this.handlerArr(this.memberInfo4Client.clientInfo);
      } else {
        this.memberInfo4Client.clientInfo.forEach((v, i) => {
          if (obj.id == v.id) {
            this.memberInfo4Client.clientInfo.splice(i, 1);
          }
        });
        this.memberInfo4Client.clientInfo = this.handlerArr(this.memberInfo4Client.clientInfo);
      }
      this.$refs.staffCustomer.checkMemberList = [];
    },
    handlerArr(tempArr) {
      let result = [];
      let obj = {};
      for (let i = 0; i < tempArr.length; i++) {
        if (!obj[tempArr[i].id]) {
          result.push(tempArr[i]);
          obj[tempArr[i].id] = true;
        }
        ;
      }
      ;
      return result;
    },
    cancelChooseMember() {
      this.chooseStyle = this.chooseStyleOld;
      this.dialogMemberTree = false;
    },
    preserStaff() {
      this.chooseStyleOld = this.chooseStyle;
      if (this.chooseStyle === "all") {
        this.memberInfo4Client.clientInfo = [];
      }
      if (!this.entryData[this.activeEntryIndex].conditions[this.activeConditionsIndex]){
        this.entryData[this.activeEntryIndex].conditions[this.activeConditionsIndex] = {
          visible: true,
          type: "",
          expect: [],
          key: "",
          relation: ""
        }
      }
      if (this.chooseStyle === "all") {
        this.memberInfo4Client = {
          clientInfo: []
        };
        this.entryData[this.activeEntryIndex].conditions[this.activeConditionsIndex].expect = [];
        this.entryData[this.activeEntryIndex].conditions[this.activeConditionsIndex].type = "ALL";
      } else {
        this.entryData[this.activeEntryIndex].conditions[this.activeConditionsIndex].expect = this.memberInfo4Client.clientInfo;
      }
      this.dialogMemberTree = false;
      console.log('dialogMemberTree',this.dialogMemberTree, this.entryData[this.activeEntryIndex].conditions,this.activeConditionsIndex)
    },
    gotoIntelligentAgentConfig(){

    },
    //部门是否使用通讯录组件
    isOpenData(value) {
      /* const res = /^\d+$/;
       console.debug('value',res.test(value))*/
      let bool = false;
      if (this.orgTree.length > 1) {
        if (this.orgTree[0].originData &&
            this.orgTree[0].originData.wechatBotDTO &&
            this.orgTree[0].originData.wechatBotDTO.bindType === 0 &&
            this.orgTree[0].originData.wechatBotDTO.wechatType === 0) {
          bool = true;
        } else if (this.orgTree[1].originData &&
            this.orgTree[1].originData.wechatBotDTO &&
            this.orgTree[1].originData.wechatBotDTO.bindType === 0 &&
            this.orgTree[1].originData.wechatBotDTO.wechatType === 0) {
          bool = true;
        }
      } else if (this.orgTree.length === 1) {
        if (this.orgTree[0].originData &&
            this.orgTree[0].originData.wechatBotDTO &&
            this.orgTree[0].originData.wechatBotDTO.bindType === 0 &&
            this.orgTree[0].originData.wechatBotDTO.wechatType === 0) {
          bool = true;
        }
      }
      return bool;
    },
    // 获取部门树
    getDepartmentTree(){
      let userId = localStorage.getItem("_uid");
      let url = "/api/department/corpListLazy" + "?userId=" + userId;
      this.$http.get(url).then(res => {
        console.log('getDepartmentTree',res)
        this.orgTree = res.data;
      })
    },
    getEntranceConfig(){
      let url = "/api-open/channel/access/entrance-config";
      this.$http.get(url).then(res => {
        console.log('getEntranceConfig',res)
        if (res.data.code == 0 && res.data.data){
          this.entryList = res.data.data;
        }
      })
    },
    updateConfig(callBack){
      let url = "/api-open/channel/access/update-access-config?bindCode=" + this.$route.query.bindCode;
      let data = this.entryData.filter(item => item.entranceCode);
      if (data.length == 0){
        return
      }
      let obj = {
        entranceConfig:data
      }
      this.$http.post(url,obj).then(res => {
        console.log('res',res)
        callBack(res)
      })
    },
  },
  mounted() {
    this.getTagsOptions();
    this.getDepartmentTree();
    this.getEntranceConfig();
    if (this.$route.query.type === "wechatAccount") {
      this.isFwh = true;
    }
    this.$nextTick(() => {
      if (this.bindDetail && this.bindDetail.accessConfig){
        let entranceConfig = JSON.parse(this.bindDetail.accessConfig).entranceConfig
        this.entryData = entranceConfig;
      }
    })
  }
};
</script>

<style scoped lang="less">
.default_entry{
  width: 100%;

  .entry_table{
    width: 100%;
    border: 1px solid #E0E6F7;
    border-radius: 5px;
    .table_title{
      display: flex;
      align-items: center;
      height: 39px;
      border-radius: 5px 5px 0px 0px;
      padding: 0 10px 0 10px;
      margin-bottom: 8px;
      background: #F6F8FD;
      .table_title_left{
        flex: none;
        width: 200px;
      }
      .table_title_right{
        flex: 1;
        margin-left: 16px;
      }
      .table_title_op{
        flex: none;
        width: 30;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .table_list{
      display: flex;
      align-items: center;
      padding: 0 10px 10px 10px;
      .select_entry{
        flex: none;
        width: 200px;
      }
      .right-consultation-scope {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex: 1;
        margin-left: 16px;
        .right-consultation-scope-top {
          display: flex;
          align-items: center;
          width: 100%;
          position: relative;
          .right-consultation-scope-top-content {
            min-height: 36px;
            border: 1px solid #DCDFE6;
            border-radius: 5px;
            display: flex;
            align-items: center;
            flex: 1;
            max-width: 328px;
          }
          .error-content {
            border: 1px solid red;
            width: calc(100% - 25px);
            flex: none;
          }
          .del-ondition {
            margin-left: 10px;
            color: #366AFF;
            cursor: pointer;
          }

          .select-cell-et {
            flex: none;
            width: 200px;
          }

          .select-cell-eteq {
            flex: none;
            width: 100px;
          }

          .select-cell-etv {
            flex: auto;
          }

          .select-cell-attr {
            flex: none;
            width: 110px;
            display: flex;
            align-items: center;

            .choose-user-attrible {
              text-align: left;
              width: 100%;
              height: 100%;
              cursor: pointer;
              padding: 0 15px;
              color: #606266;

              &.empty-user-attrible {
                color: #d5d5d5;
              }
            }
          }

          .select-cell-attreq {
            flex: none;
            width: 90px;
            display: flex;
            align-items: center;

            /deep/ .el-input {
              .el-input__inner {
                border: none;
                box-shadow: none;
                padding: 0 10px;
              }

              .el-select__caret {
                display: none;
              }
            }
          }

          .select-cell-attrv {
            flex: auto;
            // display: flex;
            // align-items: center;
            // padding: 6px;
            // width: 100%;
            line-height: 36px;

            .attr-value {
              display: block;
              width: 100%;
              height: 100%;
              cursor: pointer;
            }

            .select-cell-attrv-placeholder {
              color: #c0c4cc;
              cursor: pointer;
            }

            .choose-tag-select {
              .el-input__inner {
                border: none;
              }
            }
          }
          .select-cell-placeholder {
            min-height: 36px;
            border: 1px solid red;
            border-radius: 5px;
            display: flex;
            align-items: center;
            flex: 1;
            color: #606266;
            cursor: pointer;
            padding-left: 12px;
          }
        }

        .add-condition-bot-btn {
          cursor: pointer;
          margin-left: 10px;
          i{
            color: #366aff;
          }

          span {
            cursor: pointer;
            color: #366AFF;
          }
        }

        /deep/ .el-select__input {
          border: none;
        }

        /deep/ .el-input__inner {
          border: none;
        }
        .and-box{
          position: absolute;
          left: -10px;
          top: 30px;
          width: 18px;
          height: 18px;
          background: #366AFF;
          font-size: 12px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: none;
          color: #ffffff;
          z-index: 99;
        }
      }
      .del-bind-bot {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;

        &.ml {
          margin-right: 0px;
          margin-left: 10px;
        }

        .guoran-tongyichicun-16-09-shanchu2 {
          cursor: pointer;
          color: #366AFF;
        }

        .guoran-a-18-13 {
          color: red;
          cursor: pointer;
        }
      }
    }
  }
}
.add_entry {
  display: flex;
  align-items: center;
  color: #366aff;
  cursor: pointer;
  margin-top: 30px;

  .addIcon {
    flex: none;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #366aff;
    margin-right: 10px;
    border-radius: 5px;

    i {
      color: #FFFFFF;
    }
  }

}
.intelligentAgentItem{
  display: flex;
  align-items: center;
  line-height:20px;
  padding: 10px;
  border-bottom: 1px solid #E4E9F2;
  width: 150px;
  cursor: pointer;
}
/deep/ #popup-assembly {
  width: 800px !important;

  .choose-style {
    text-align: left;

    > div {
      font-size: 14px;
      font-weight: bold;
      color: #000000;
      margin-bottom: 20px;
    }

    .radio-box {
      height: 40px;
      background: #FBFCFD;
      border-radius: 5px;
      display: flex;
      align-items: center;
      padding: 0 20px;

      .el-radio {
        width: 40%;
      }
    }
  }
}
</style>